import React from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import moment from "moment/min/moment-with-locales";
import clsx from "clsx";
import { CheckCircle } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { styled } from "@mui/material";
import theme from "../theme";

export const ActivitatBox = styled(Box)(({ theme }) => ({
	cursor: "pointer",
	padding: 15,
	backgroundColor: "white",
	marginTop: 8,
	border: "5px solid white",
	transition: "0.2s",
	position: "relative",
	height: 300,
	"&.active": {
		border: "5px solid " + theme.palette.success.main,
	},
}));

export const TextAlt = styled(Typography)(({ theme }) => ({
	color: theme.palette.small.main,
	fontSize: "0.9rem",
}));

const ActivitatWeek = (props) => {
	const { activitat, color, setFieldValue, values, setContinuar } = props;
	const matches = useMediaQuery("(min-width:960px)");

	return (
		<Tooltip
			title={
				Number(activitat?.alumnes_count) >= Number(activitat?.places)
					? "Activitat plena. Contacta amb nosaltres."
					: String(activitat?.publicada) === "0"
					? "Activitat no oberta a inscripcions."
					: ""
			}
			// disableHoverListener={
			//     Number(activitat?.alumnes_count) !==
			//         Number(activitat?.places) && String(activitat?.publicada) === "0"
			// }
			arrow
		>
			<ActivitatBox
				className={values.activitat?.includes(activitat.id) && "active"}
				style={{
					opacity:
						Number(activitat?.alumnes_count) >=
						Number(activitat?.places)
							? 0.5
							: String(activitat?.publicada) === "1"
							? 1
							: 0.5,
				}}
				onClick={() => {
					if (String(activitat?.publicada) === "1") {
						if (values.activitat?.includes(activitat?.id)) {
							let newValues = values.activitat.filter(function (
								element
							) {
								return element !== activitat?.id;
							});
							setFieldValue("activitat", newValues);
							if (newValues.length > 0) {
								setContinuar(true);
							} else {
								setContinuar(false);
							}
						} else {
							setFieldValue("activitat", [
								...values.activitat,
								activitat?.id,
							]);
							setContinuar(true);
						}
					}
				}}
			>
				<Box pb={2}>
					<Typography
						variant="body1"
						style={{ fontSize: "0.9rem", fontWeight: 700 }}
					>
						{moment(activitat.hora_i, "HH:mm:ss").format("H:mm")} -{" "}
						{moment(activitat.hora_f, "HH:mm:ss").format("H:mm")} h
					</Typography>
				</Box>
				<Box pb={2}>
					<Typography
						variant="caption"
						style={{ color: color, fontSize: 12 }}
					>
						{activitat.curs}
					</Typography>
					<Typography variant="h4" style={{ color: color }}>
						{activitat.nom}
					</Typography>
					<Typography
						variant="caption"
						style={{ color: color, fontSize: 12 }}
					>
						{activitat.descripcio}
					</Typography>
				</Box>
				<Box pb={2}>
					{Number(activitat.preu_soci) ? (
						<TextAlt variant="body1">
							{activitat.preu_soci} € mensuals (socis AFA)
						</TextAlt>
					) : (
						""
					)}
					{Number(activitat.preu) ? (
						<TextAlt variant="body1">
							{activitat.preu} € mensuals
						</TextAlt>
					) : (
						""
					)}
				</Box>

				<TextAlt variant="body1">{activitat.imparteix}</TextAlt>
				<TextAlt variant="body1">
					Places: {activitat?.alumnes_count}/{activitat?.places}
				</TextAlt>
				{Number(activitat?.alumnes_count) >=
					Number(activitat?.places) && (
					<TextAlt variant="body1" style={{ fontSize: 11 }}>
						Places plenes. Si la selecciones, et posarem a la llista
						d'espera
					</TextAlt>
				)}
				{values.activitat?.includes(activitat.id) && (
					<CheckCircle
						style={{
							top: matches ? 15 : 45,
							fill: theme.palette.success.main,
							position: "absolute",
							right: 15,
						}}
					/>
				)}
				<Box sx={{ display: { xl: "none", xs: "block" } }}>
					<Box
						style={{
							backgroundColor: color,
							position: "absolute",
							right: -5,
							top: -5,
							padding: 10,
						}}
					>
						<Typography
							variant="body1"
							style={{ color: "white" }}
							textTransform={"uppercase"}
						>
							{activitat.dia
								? moment(activitat.dia, "e")
										.locale("ca")
										.format("dddd")
								: "Diària"}
						</Typography>
					</Box>
				</Box>
			</ActivitatBox>
		</Tooltip>
	);
};

export default ActivitatWeek;
